const ServiceTypes = {
  FOOD: 'food',
  MEDICINE: 'medicine',
  MAHLZEIT: 'mahlzeit'
};

export default ServiceTypes;
